import Vue from 'vue'

import { directive as vueClickAway } from 'vue-clickaway'

Vue.directive('clickAway', vueClickAway)
